import React from "react";
import ScopedListing from "./ScopedListing";
import { useI18n } from "../lib/i18n";

/* `outlet` is a column on the product, filtered server-side; no new endpoint. */
const SCOPE = { outlet: true };

export default function OutletPage() {
  const { t } = useI18n();
  return (
    <ScopedListing
      scope={SCOPE}
      path="/outlet"
      testId="outlet-page"
      listName="outlet"
      heroIndex={2}
      eyebrow={t("outlet.eyebrow", "Keçən sezon")}
      title={t("outlet.title", "OUTLET")}
      description={t(
        "outlet.description",
        "Keçən sezonun parçaları — eyni dərzilik, azaldılmış qiymətlə. Sayı məhduddur.",
      )}
      emptyTitle={t("outlet.empty", "Hazırda outlet-də məhsul yoxdur")}
      emptyDescription={t(
        "outlet.empty_help",
        "Yeni endirimlər əlavə olunanda burada görünəcək. Bu arada kataloqa baxa bilərsiniz.",
      )}
    />
  );
}
